export const MODAL_DIALING_SECTIONS = {
  LIST_DIALER: "list-dialer",
  GENERAL_DIALER: "general-dialer",
} as const;
